import { PagedSingleSelectField } from "@dgs/core";
import React, { FC } from "react";
import { customerKeys, customerService } from "~shared/api/customer";

interface Props {
	name: string;
	label: string;
}

const fetcher = (search: string, page: number) =>
	customerService.options({ params: { search, page } }).then((r) => r.data);

export const CustomerSingleSelectField: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetcher={fetcher} queryKey={customerKeys.options} required={true} />;
};
